import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { FileText } from 'lucide-react';
import { useState } from 'react';

export const SummarySettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <FileText className="w-5 h-5 text-primary" />
          <CardTitle>Sammendrag av Kai</CardTitle>
        </div>
        <CardDescription>
          Konfigurer AI-genererte sammendrag av artikler
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="summary-enabled">Aktivert</Label>
          <Switch
            id="summary-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>Innstillinger</Label>
          <p className="text-sm text-muted-foreground">
            Her kan du konfigurere hvordan Kai genererer sammendrag av artikler,
            inkludert lengde, tone og strukturering.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
